import { z } from 'zod';

export const adminPoisSearchSchema = z.object({
  osmKey: z.string().optional(),
  osmValue: z.string().optional(),
  showDeleted: z.boolean().optional(),
});

export type AdminPoisSearch = z.infer<typeof adminPoisSearchSchema>;

export function validateAdminPoisSearch(search: Record<string, unknown>): AdminPoisSearch {
  return adminPoisSearchSchema.catch({}).parse(search);
}
